import { FormikProvider, useFormik } from 'formik';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import Field, { FieldType } from 'packages/kakapo-ui-kit/components/forms/controls/Field';
import Modal, {
	ModalBackground,
	ModalContent,
} from 'packages/kakapo-ui-kit/components/modals/Modal';
import ModalHeader, {
	ModalHeaderTitle,
} from 'packages/kakapo-ui-kit/components/modals/ModalHeader';

export function UserUpdateMissionModalForm(props: { user: graphql.User; returnURL?: string }) {
	const { t } = useTranslation();
	const history = useHistory();
	const [updateMission, { loading }] = graphql.useUserUpdateMissionMutation();

	const formik = useFormik({
		initialValues: {
			mission: props.user.mission,
		},
		onSubmit: async (values) => {
			await updateMission({
				variables: {
					input: {
						id: props.user.id,
						mission: values.mission,
					},
				},
			});

			if (props.returnURL) {
				history.push(props.returnURL);
			}
		},
	});

	return (
		<FormikProvider value={formik}>
			<Field
				name="mission"
				type={FieldType.Text}
				label={t('users.updateMission.modal.label')}
				fullWidth
			/>
			<Button
				title={t('users.updateMission.modal.save')}
				loading={loading}
				onClick={() => formik.submitForm()}
				flexGrow={0}
			/>
		</FormikProvider>
	);
}

export default function UserUpdateMissionModal(props: { id: string; returnURL: string }) {
	const { t } = useTranslation();
	const { data } = graphql.useUserQuery({ variables: { id: props.id } });

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader returnUrl={props.returnURL}>
					<ModalHeaderTitle>{t('users.updateMission.modal.title')}</ModalHeaderTitle>
				</ModalHeader>
				<ModalContent>
					{data ? (
						<UserUpdateMissionModalForm
							user={data.user as graphql.User}
							returnURL={props.returnURL}
						/>
					) : (
						<Spinner size="18px" isLoading />
					)}
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
}
